import { orchestrator } from 'satcheljs';
import { contactSupport } from '../actions/contactSupport';
import { hideFullOptions } from 'owa-options-core';
import { logUsage } from 'owa-analytics';
import { launchSuiteHelpPane } from 'owa-suitehelp-utils';
export default orchestrator(contactSupport, async function contactSupport() {
    hideFullOptions();
    launchSuiteHelpPane();
    logUsage('PremiumDashContactPremiumSupport', null, { isCore: true });
});
